/**
 * Centralized ad_type values used by Ads API and frontend rendering.
 */

export class AdTypes {
    public static PLACE_HOLDER = "PLACE_HOLDER";
    public static PRODUCT_LINKER = "PRODUCT_LINKER";
    public static PRODUCT_LINKER_OGP = "PRODUCT_LINKER_OGP";
    public static PRODUCT_CARD = "PRODUCT_CARD";
    public static TOP_BANNER = "TOP_BANNER";
}
